  document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  
  checkboxes.forEach(function(checkbox) {
    const svgElements = checkbox.parentNode.querySelectorAll('svg');
    const checkmarkIcon = checkbox.parentNode.querySelector('.icon-checkmark');
    
    checkbox.addEventListener('click', function() {
      svgElements.forEach(function(svgElement) {
        svgElement.classList.toggle('active');
      });
      
      checkmarkIcon.classList.toggle('active');
    });
  });
});




const form = document.getElementById('ContactFooter');
  form.addEventListener('submit', function(event) {
    event.preventDefault();
});



const dropdownDisclosures = document.querySelectorAll('.header__inline-menu details');
dropdownDisclosures.forEach((dropdownDisclosure) => {
  dropdownDisclosure.addEventListener('toggle', function() {
    if (dropdownDisclosure.open) {
      document.body.classList.add('module-test');
    } else {
      document.body.classList.remove('module-test');
    }
  });
});



$(window).scroll(function() {
  var logo = $('.fixed-logo');
  var windowHeight = $(window).height();
  var scrollTop = $(window).scrollTop();
  var distanceFromBottom = $(document).height() - (scrollTop + windowHeight);
  if (distanceFromBottom <= 300) {
    logo.addClass('hide-logo');
  } else {
    logo.removeClass('hide-logo');
  }
});




var currentUrl = window.location.href;
  var menuItems = document.querySelectorAll('.tag-filters__item');
  for (var i = 0; i < menuItems.length; i++) {
    var menuItem = menuItems[i];
    var menuItemUrl = menuItem.getAttribute('href');
    if (currentUrl.indexOf(menuItemUrl) !== -1) {
      menuItem.classList.add('active_bar');
    }
  }










$("#main-class").on('click', 'li', function () {
$("#main-class li.active").removeClass("active");
$(this).addClass("active");
});






$(document).ready(function(){
  $(".facets__display1").click(function(){
    $(".filter-ione-term").removeClass("team1");
    $("icone_d1").removeClass("megenta");
 
  });
});



$(document).ready(function(){
  $(".icone_d1").click(function(){
    $(this).toggleClass("megenta");
    $(".filter-ione-term").toggleClass("team1");
 
  });
});




$(document).ready(function(){
  $(".mobil-short-item").click(function(){
    $(this).toggleClass("open-item");
 
  });
});




$(document).ready(function(){
  $(".short_label_terminal").click(function(){
    $(this).toggleClass("add-icone");
    $(".term-value").toggleClass("main_open");
  });
});




$(document).ready(function(){
  $(".up-one").click(function(){
    $(".filter-gacet-top").removeClass("main-filter");
    $(".filter-btn").removeClass("add-icone");
  });
  $("#btn-face").click(function(){
    $(".term-value").removeClass("main_open");
    $(".short_label_terminal").removeClass("add-icone");
  });
});



$(document).ready(function(){
  $("#main-country-item2").click(function(e){
    e.stopPropagation();
    $(".country-wrap").toggleClass("country-small-code");
    $(".PageOverlay").toggleClass("item-visible");
  });

  $(document).click(function(){
    $(".country-wrap").removeClass("country-small-code");
    $(".PageOverlay").removeClass("item-visible");
  });
});



$(document).ready(function(){
  $("#main-country-item").click(function(e){
    e.stopPropagation();
    $(".country-wrap").toggleClass("country-small-code");
  });

  $(document).click(function(){
    $(".country-wrap").removeClass("country-small-code");
  });
});




$(document).ready(function(){
  $("#btn-face").click(function(){
    $(this).toggleClass("add-icone");
    $(".filter-gacet-top").toggleClass("main-filter");
  });
});




$(document).ready(function(){
  $(".txxt_cp").click(function(){
    $(".terminal-view-items").toggleClass("main-drop");
  });
});



var links = document.getElementsByClassName("mylink");
    for (var i = 0; i < links.length; i++) {
        var link = links[i];
        if (document.body.classList.contains("en")) {
            var href = link.getAttribute("href");
            link.setAttribute("href", "/en" + href);
        }
    }






  jQuery(document).ready(function (e) {
    function t(t) {
        e(t).bind("click", function (t) {
            t.preventDefault();
            e(this).parent().fadeOut()
        })
    }
    e(".dropdown-toggle").click(function () {
        var t = e(this).parents(".button-dropdown").children(".dropdown-menu").is(":hidden");
        e(".button-dropdown .dropdown-menu").hide();
        e(".button-dropdown .dropdown-toggle").removeClass("active");
        if (t) {
            e(this).parents(".button-dropdown").children(".dropdown-menu").toggle().parents(".button-dropdown").children(".dropdown-toggle").addClass("active")
        }
    });
    e(document).bind("click", function (t) {
        var n = e(t.target);
        if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-menu").hide();
    });
    e(document).bind("click", function (t) {
        var n = e(t.target);
        if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-toggle").removeClass("active");
    })
});



$(document).ready(function(){
  $(".unic-menu").click(function(){
    $(".header").addClass("menu-block");
  });
  $(".back-items").click(function(){
    $(".header").removeClass("menu-block");
  });
});


  $(document).ready(function() {
  $('.close-menus').click(function() {
    $('.header__icon').trigger('click');
  });
});


$(function() {
  $("#navMenus, li").on("click", function(e) {
    $(this).addClass("active");
    e.stopPropagation()
  });
  $(document).on("click", function(e) {
    if ($(e.target).is("#navMenus, li") === false) {
      $("navMenus, li").removeClass("active");
    }
  });
});




$(document).ready(function(){
  $("#search-items").click(function(){
    $(".mob-search-popup").addClass("active");
    $("body").addClass("active_s1");
  });
});



$(document).ready(function(){
  $(".term-fade-item").click(function(){
    $(".main-fade").addClass("classic-item");
  });
});




	$("#navMenus12").on('click', '.term-fade-item', function () {
    $("#navMenus12 .term-fade-item.active").removeClass("active");
    $(this).addClass("active");
});


document.addEventListener('DOMContentLoaded', function() {
      var deviceLoadLabels = document.querySelectorAll('.term-fade-item ');
      for (var i = 0; i < deviceLoadLabels.length; i++) {
        deviceLoadLabels[i].addEventListener('click', function() {
          setTimeout(function() {
            location.reload();
          }, 500); // 3 seconds
        });
      }
    });











